import { Box, Button, Divider, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react'; 
import {BiGhost, BiCollection} from 'react-icons/bi'; 
import {FiLayers, FiGrid, FiSmartphone} from 'react-icons/fi'; 
import { Link, useNavigate } from 'react-router-dom';
import theme from '../../muiTheme';
import placeHolderImage from "../../images/post_placeholder.jpeg";
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useWindowScrollPositions } from '../../hooks/useWindowScrollPositions';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import './styles.scss'; 

const LandingPage = ({anchor, sx}) => {

    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 768px)');
    const [user, setUser] = useState(null); 
    const [pageBackground, setPageBackground] = useState('linear-gradient(to right, #b24592, #f15f79)'); 
    const [opacity, setOpacity] = useState(1);
    const authStateSlice = useSelector((state) => state.authReducer);

    useEffect(()=>{
        //load user info
        let profile = JSON.parse(localStorage.getItem('profile'))?.result || null; 

        setUser(profile);
    }, []);

    useEffect(()=>{

        
        //load user info
        let profile = JSON.parse(localStorage.getItem('profile'))?.result || null; 

        setUser(profile);
    }, [authStateSlice]);

    const handleClick = (target) => {

        if(target==='explore'){

            navigate('/explore');

        }else if(target === 'latest' && anchor) {

            //scroll down smoothly
            anchor.current.scrollIntoView({behavior: 'smooth'}); 
        }
    }


    return (
        <Box
            display={{xs: 'flex'}}
            flexDirection={{xs: 'column'}}
            height={{xs: '100vh'}}
            width={{xs: '100vw'}}
            backgroundColor={{xs: 'white'}}
            justifyContent={{xs: 'center'}}
            alignItems={{xs:'center'}}
            sx={{...sx, overflow: 'hidden'}}
            className='force-gpu-render'
        >

            <Box
                
                display={{xs: 'flex'}}
                flexDirection={{xs: 'column'}}
                height={{xs: '100vh'}}
                width={{xs: '100vw'}}
                justifyContent={{xs: 'center'}}
                alignItems={{xs:'center'}}
                sx={{background: pageBackground, transition: '0.2s', backgroundSize: 'cover', opacity: opacity}}
            >

                <Box
                
                    display={{xs: 'flex'}}
                    flexDirection={{xs: 'column'}}
                    height={{xs: 'auto'}}
                    width={{xs: '100vw'}}
                    justifyContent={{xs: 'center'}}
                    alignItems={{xs:'center'}}
                >

                    <BiGhost style={{fontSize: isMobile ? '100px' :'180px', color: 'white'}}/>

                    <Typography variant='logo'  sx={{color: 'white'}}>
                        QuickShot
                    </Typography>

                </Box>

                <Box
                
                    display={{xs: 'flex'}}
                    flexDirection={{xs: 'column'}}
                    height={{xs: 'auto'}}
                    width={{xs: '100vw'}}
                    justifyContent={{xs: 'center'}}
                    alignItems={{xs:'center'}}
                    sx={{marginTop: '50px'}}
                >

                    {
                        user ? 

                            <>
                                <Typography variant='h5'  sx={{color: 'white', marginBottom: '20px'}}>
                                    Hello there
                                </Typography>

                                <Typography variant='h4'  sx={{color: 'white'}}>
                                    {user.name}
                                </Typography>
                            </>
                            

                        :

                        <>
                        
                            <Typography variant='h5'  sx={{color: 'white'}}>
                            Join the party
                            </Typography>

                            <Button component={Link} to='/auth' variant='inverted' color='secondary' sx={{marginTop: '30px'}}>
                                Sign Up / Sign In
                            </Button>

                        </>

                    }
                    

                </Box>

                <Divider sx={{borderColor: '#ffffff99', width: '300px', marginTop: '30px'}}/>

                <Box
                
                    display={{xs: 'flex'}}
                    flexDirection={{xs: 'row'}}
                    height={{xs: 'auto'}}
                    width={{xs: '300px'}}
                    justifyContent={{xs: 'space-evenly'}}
                    alignItems={{xs:'flex-start'}}
                    sx={{marginTop: '0px', textAlign: 'center', color: 'white'}}
                >

                    <Box
                        display={{xs: 'flex'}}
                        flexDirection={{xs: 'column'}}
                        height={{xs: 'auto'}}
                        width={{xs: '100px'}}
                        justifyContent={{xs: 'center'}}
                        alignItems={{xs:'center'}}
                        sx={{marginTop: '50px', cursor: 'pointer'}}
                        onClick={()=>{handleClick('latest')}}
                    >

                        <BiCollection style={{fontSize: '30px', marginBottom: '20px'}}/>

                        <Typography variant='body2'>
                            Latest 
                        </Typography>

                    </Box>

                    <Box
                        display={{xs: 'flex'}}
                        flexDirection={{xs: 'column'}}
                        height={{xs: 'auto'}}
                        width={{xs: '100px'}}
                        justifyContent={{xs: 'center'}}
                        alignItems={{xs:'center'}}
                        sx={{marginTop: '50px', cursor: 'pointer'}}
                        onClick={()=>{handleClick('explore')}}
                    >

                        <FiGrid style={{fontSize: '30px', marginBottom: '20px'}}/>

                        <Typography variant='body2'>
                            Explore
                        </Typography>

                    </Box>

                </Box>
            
            </Box>

        </Box>
    ); 
}


export default LandingPage; 